import { render, staticRenderFns } from "./InputKlinik.vue?vue&type=template&id=725df48a&scoped=true&"
import script from "./InputKlinik.vue?vue&type=script&lang=js&"
export * from "./InputKlinik.vue?vue&type=script&lang=js&"
import style0 from "./InputKlinik.vue?vue&type=style&index=0&id=725df48a&scoped=true&lang=css&"
import style1 from "./InputKlinik.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725df48a",
  null
  
)

export default component.exports